import { useState } from "react";
import * as Comp from "../../../common/CommonComponents";
import * as common from "../../../common/common";
import CssClass from "../../../Styles/common.module.css";
import ModifyTicketStatusType from "./ModifyTicketStatusType";
import DeleteTicketStatusType from "./DeleteTicketStatusType";
import TicketStatusTypeActivator from "./TicketStatusTypeActivator";
import edit from "../../../assets/edit-icon.png";
import deleteIcon from "../../../assets/delete-icon.png";
import moment from "moment";

const TicketStatusTypeListTable = (props) => {

	//#region React Hooks
	const [showEdit, setShowEdit] = useState(false);
	const [showDelete, setShowDelete] = useState(false);
	const [showActivator, setShowActivator] = useState(false);
	const [editData, setEditData] = useState([]);
	//#endregion

	//#region Modal Show/Hide
	const showEditModal = (e, row) => {

		setShowEdit(!showEdit);
		setEditData(row);
	};

	const hideEditModal = () => {
		setShowEdit(!showEdit);
		setEditData(null);
	};

	const showActivatorModal = (e, row) => {
		setShowActivator(!showActivator);
		setEditData(row);
	};
	
	const hideActivatorModal = () => {
		setShowActivator(!showActivator);
		setEditData(null);
	};

	const showDeleteModal = (e, row) => {
		setShowDelete(!showDelete);
		setEditData(row);
	};

	const hideDeleteModal = () => {
		setShowDelete(!showDelete);
		setEditData(null);
	};
	//#endregion

    //#region Table Columns
	const columns = [
		{
			accessorKey: "TICKET_STATUS_TYPE_NAME",
			header: "Ticket Status Type",
			size: 120,
		},
		{
			accessorKey: "REMARK",
			header: "Remark",
			size: 120,
		},		
		{
			id: "STATUS",
			header: "Status",
			size: 80,
			accessorFn: (row) => {
			  const className =
				row.STATUS === "Active"
				  ? CssClass.activeStatus
				  : CssClass.inactiveStatus;

				const handleActivatorClick = (e, row) => {
					showActivatorModal(e, row);
				};

			  return (
				<div className={CssClass.toggleWrapper}>
				  {/* <span className={className}>{row.STATUS}</span> */}
				  <label className={CssClass.switch}>
					<input
					  type="checkbox"
					  checked={row.STATUS === "Active"}
					  onChange={(e) => handleActivatorClick(e, row)}
					/>
					<span className={CssClass.sliderRound}></span>
				  </label>
				</div>
			  );
			},
		  },	
        {
			accessorKey: "UPDATE_NAME",
			header: "Last Update By",
			size: 120,
		},
		{
			accessorKey: "UPDATE_DATETIME",
			header: "Last Update Date Time",
			size: 200,
			Cell: ({ cell }) =>
				cell.getValue() === "0001-01-01T00:00:00"
				  ? "-"
				  : moment(cell.getValue()).format("DD/MM/YYYY hh:mm A"),
		},
        {
			id: "Action",
			header: "Action",
			size: 150,
			//classes: CssClass.tdBtnActionWrapperOne,
			accessorFn: (row) => (
				<div>
					<span>
						<span title="Modify">
							<Comp.Button
								id="btnEdit"
								type="general"
								onClick={(e) => showEditModal(e, row)}
								style={{ width: "60px", height: "40px" }}
							>
								<img src={edit} alt="Edit" style={{ width: "22px", height: "22px" }} />
							</Comp.Button>	
						</span>
						{/* <Comp.Button
              				id="btnActivator"
              				type="activator"
              				onClick={(e) => showActivatorModal(e, row)}
           				 >
              				{row.ACTIVE_FLAG === "Y" ? "DEACTIVATE" : "ACTIVATE"}
            			</Comp.Button>					 */}
						<span title="Delete">
							<Comp.Button
								id="btnDelete"
								type="delete"
								onClick={(e) => showDeleteModal(e, row)}
								style={{ width: "60px", height: "40px" }}
							>
								<img src={deleteIcon} alt="Unlock" style={{ width: "26px", height: "26px" }} />
							</Comp.Button>
						</span>
					</span>
				</div>
			),
		},
	];
	//#endregion

    return (
		<>
			<Comp.Table
				columns={columns}
				data={props.data}
				invisibleCol={{ Action: (props.actionAuthority.WRITE !== "Y") ? false : true }} 
				/>
			<ModifyTicketStatusType
				page={props.page}
				module={props.module}
				showHide={showEdit}
				editData={editData}
				//dataToBeSelect={props.dataToBeSelect}
				onHide={hideEditModal}
				onReload={props.onReload}
				onLoading={props.onLoading}
			/>
			<TicketStatusTypeActivator
          		page={props.page}
          		module={props.module}
          		showHide={showActivator}
          		editData={editData}
          		onHide={hideActivatorModal}
          		onReload={props.onReload}
          		onLoading={props.onLoading}
        	/>
			<DeleteTicketStatusType
				page={props.page}
				module={props.module}
				showHide={showDelete}
				editData={editData}
				onHide={hideDeleteModal}
				onReload={props.onReload}
				onLoading={props.onLoading}
			/>
		</>
	);
};

export default TicketStatusTypeListTable;